import App from "../../services/App/App.js";
import AppModule from "../../services/App/AppModule.js";
import AppModuleAttr from "../../services/App/AppModuleAttr.js";
import AppModuleType from "../../services/App/AppModuleType.js";
import RouterModel from "../../router/RouterModel.js";

import SlrcD from "./Details/SlrcD.vue";
import SlrcExD from "./ExportDetails/SlrcExD.vue"
import SlrcL from "./List/SlrcL.vue";
import SlrcN from "./New/SlrcN.vue";
import SlrcPD from "./PrintDetails/SlrcPD.vue";
import SlrcExl from "./ExportList/SlrcExL.vue";
import SlrcPL from "./PrintList/SlrcPL.vue";

export default {
  Path: {
    Details: RouterModel.getPath(AppModule.SalesRecap, AppModuleType.Details),
    ExportDetails: RouterModel.getPath(AppModule.SalesRecap, AppModuleType.ExportDetails),
    ExportList: RouterModel.getPath(AppModule.SalesRecap, AppModuleType.ExportList),
    List: RouterModel.getPath(AppModule.SalesRecap, AppModuleType.List),
    New: RouterModel.getPath(AppModule.SalesRecap, AppModuleType.New),
    PrintDetails: RouterModel.getPath(AppModule.SalesRecap, AppModuleType.PrintDetails)
  },

  getRoutes() {
    return [
      {
        path: RouterModel.getPath(AppModule.SalesRecap, AppModuleType.Details),
        name: RouterModel.getName(AppModule.SalesRecap, AppModuleType.Details),
        component: SlrcD,
        meta: {
          title: RouterModel.getNavSubTitle(AppModule.SalesRecap, AppModuleType.Details),
          module: RouterModel.getModule(AppModule.SalesRecap),
          moduleattr: AppModuleAttr.SalesRecap_Act_Details,
          moduletype: AppModuleType.Details
        }
      },
      {
        path: RouterModel.getPath(AppModule.SalesRecap, AppModuleType.ExportDetails),
        name: RouterModel.getName(AppModule.SalesRecap, AppModuleType.ExportDetails),
        component: SlrcExD,
        meta: {
          title: RouterModel.getNavSubTitle(AppModule.SalesRecap, AppModuleType.ExportDetails),
          module: RouterModel.getModule(AppModule.SalesRecap),
          moduleattr: AppModuleAttr.SalesRecap_Act_ExportDetails,
          moduletype: AppModuleType.ExportDetails
        }
      },
      {
        path: RouterModel.getPath(AppModule.SalesRecap, AppModuleType.ExportList),
        name: RouterModel.getName(AppModule.SalesRecap, AppModuleType.ExportList),
        component: SlrcExl,
        meta: {
          title: RouterModel.getNavSubTitle(AppModule.SalesRecap, AppModuleType.ExportList),
          module: RouterModel.getModule(AppModule.SalesRecap),
          moduleattr: AppModuleAttr.SalesRecap_Act_ExportList,
          moduletype: AppModuleType.ExportList
        }
      },
      {
        path: RouterModel.getPath(AppModule.SalesRecap, AppModuleType.List),
        name: RouterModel.getName(AppModule.SalesRecap, AppModuleType.List),
        component: SlrcL,
        meta: {
          title: RouterModel.getNavSubTitle(AppModule.SalesRecap, AppModuleType.List),
          module: RouterModel.getModule(AppModule.SalesRecap),
          moduleattr: AppModuleAttr.SalesRecap_Act_List,
          moduletype: AppModuleType.List,
          // actions
          exportlist: {
            module: RouterModel.getModule(AppModule.SalesRecap),
            moduleattr: AppModuleAttr.SalesRecap_Act_ExportList,
            moduletype: AppModuleType.ExportList
          },
          new: {
            module: RouterModel.getModule(AppModule.SalesRecap),
            moduleattr: AppModuleAttr.SalesRecap_Act_New,
            moduletype: AppModuleType.New
          },
          printlist: {
            module: RouterModel.getModule(AppModule.SalesRecap),
            moduleattr: AppModuleAttr.SalesRecap_Act_PrintList,
            moduletype: AppModuleType.PrintList
          }
        }
      },
      {
        path: RouterModel.getPath(AppModule.SalesRecap, AppModuleType.New),
        name: RouterModel.getName(AppModule.SalesRecap, AppModuleType.New),
        component: SlrcN,
        meta: {
          title: RouterModel.getNavSubTitle(AppModule.SalesRecap, AppModuleType.New),
          module: RouterModel.getModule(AppModule.SalesRecap),
          moduleattr: AppModuleAttr.SalesRecap_Act_New,
          moduletype: AppModuleType.New,
          cancel: {
            url: RouterModel.getPath(AppModule.SalesRecap, AppModuleType.List)
          },
          submit: {
            url: RouterModel.getPath(AppModule.SalesRecap, AppModuleType.Details),
            params: {
              [App.Enum.Param.ID]: [App.Enum.Response.ID]
            }
          }
        }
      }
    ];
  },

  getRootRoutes() {
    return [
      {
        path: RouterModel.getPath(AppModule.SalesRecap, AppModuleType.PrintDetails),
        name: RouterModel.getName(AppModule.SalesRecap, AppModuleType.PrintDetails),
        component: SlrcPD,
        meta: {
          title: RouterModel.getNavSubTitle(AppModule.SalesRecap, AppModuleType.PrintDetails),
          module: RouterModel.getModule(AppModule.SalesRecap),
          moduleattr: AppModuleAttr.SalesRecap_Act_PrintDetails,
          moduletype: AppModuleType.PrintDetails
        }
      },
      {
        path: RouterModel.getPath(AppModule.SalesRecap, AppModuleType.PrintList),
        name: RouterModel.getName(AppModule.SalesRecap, AppModuleType.PrintList),
        component: SlrcPL,
        meta: {
          title: RouterModel.getNavSubTitle(AppModule.SalesRecap, AppModuleType.PrintList),
          module: RouterModel.getModule(AppModule.SalesRecap),
          moduleattr: AppModuleAttr.SalesRecap_Act_PrintList,
          moduletype: AppModuleType.PrintList
        }
      }
    ];
  }
}